import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { BAlert, BButton, BModal, BSpinner } from 'bootstrap-vue-next';
import { useUserStore } from '@/store/user';
import keycloak from '@/auth/keycloak';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMfaDelete',
  props: {
    show: { type: Boolean },
    credentialId: {},
    credentialLabel: {},
    credentialType: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();

// --- Component properties ---
const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});

const deletionInProgress = ref(false);
const deletionError = ref<string | null>(null);
const deletionShowSuccess = ref(false);

// --- Handle component actions ---
async function onDeletionConfirmed() {
  if (keycloak.token === null) {
    deletionError.value =
      'Cannot delete credential, authentication failed. Refresh and try again.';
    return;
  }

  deletionInProgress.value = true;
  deletionError.value = null;
  deletionShowSuccess.value = false;

  try {
    deletionShowSuccess.value = await userStore.credentialDelete(
      props.credentialId
    );
  } catch (error: any) {
    deletionError.value = `Delete failed: ${error.message || error}`;
  } finally {
    deletionInProgress.value = false;
  }

  if (deletionShowSuccess.value) {
    setTimeout(() => {
      deletionShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 2000);
  }
}

function handleCloseModal() {
  if (!deletionInProgress.value && !deletionShowSuccess.value) {
    emits('close');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "trash",
          class: "me-2"
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Delete ", -1)),
        _createElementVNode("strong", null, _toDisplayString(props.credentialLabel), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: deletionInProgress.value || deletionShowSuccess.value,
          onClick: onDeletionConfirmed
        }, {
          default: _withCtx(() => [
            (deletionInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _createTextVNode(" Deleting " + _toDisplayString(__props.credentialType) + " ", 1),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (deletionShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createTextVNode(_toDisplayString(__props.credentialType) + " Deleted ", 1),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Delete " + _toDisplayString(__props.credentialType), 1))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createTextVNode(" Are you sure you want to delete the " + _toDisplayString(__props.credentialType) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(__props.credentialLabel), 1),
            _cache[4] || (_cache[4] = _createTextVNode("? ", -1))
          ]),
          _createVNode(_unref(BAlert), {
            modelValue: deletionError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deletionError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[1] || (_cache[1] = ($event: any) => (deletionError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(deletionError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})